import React from 'react';
import { Eye, Flag, Heart, Home, Lock, MessageCircle, Zap } from 'lucide-react';
export function PhasesTimeline() {
  const phases = [{
    id: 1,
    title: 'The Sanctuary Shield',
    desc: "Instantly dropping stress hormones (Cortisol) by creating a bulletproof 'Base Camp' where both cats feel safe.",
    icon: Home
  }, {
    id: 2,
    title: 'The Silent Handshake',
    desc: "Building a 'Shared Identity' using our Scent-Swap hack. They become friends before they ever lock eyes.",
    icon: Zap
  }, {
    id: 3,
    title: 'The Dopamine Bridge',
    desc: "Wiring their brains for peace by associating the 'other cat' with their deepest biological reward: hunger satisfaction.",
    icon: Heart
  }, {
    id: 4,
    title: 'The Visual Re-Patterning',
    desc: "De-programming the 'Aggressive Response' through our zero-risk Visual Barrier protocol.",
    icon: Eye
  }, {
    id: 5,
    title: 'Managed Micro-Meetings',
    desc: "Controlled room sharing using the '3-Minute Rule' to prevent aggression before it even starts.",
    icon: Lock
  }, {
    id: 6,
    title: 'Territory Expansion',
    desc: 'Merging their worlds without a relapse. How to expand their territory while maintaining total calm.',
    icon: Flag
  }, {
    id: 7,
    title: 'The Harmony Lock',
    desc: "The 'Hiss-Free' Life. Long-term strategies to ensure they remain inseparable nap buddies forever.",
    icon: MessageCircle
  }];
  return <section className="bg-[#0a0a0a] py-20 px-4 pt-[40px] pb-[40px]" data-id="element-99">
      <div className="max-w-4xl mx-auto" data-id="element-100">
        <div className="text-center mb-[40px]" data-id="element-101">
          <h2 className="md:text-4xl font-bold mb-4 text-[24px]" data-id="element-102">
            The 7-Phase Flow
          </h2>
          <p className="text-gray-400" data-id="element-103">A systematic approach to harmony</p>
        </div>

        <div className="relative space-y-8 before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-orange-900 before:to-transparent" data-id="element-104">
          {phases.map((phase, index) => <div key={phase.id} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-105">
              {/* Icon */}
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-2 border-orange-900 bg-[#0a0a0a] group-hover:border-orange-500 group-hover:bg-orange-900/20 transition-colors shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-[0_0_10px_rgba(255,107,0,0.2)] z-10" data-id="element-106">
                <phase.icon className="w-5 h-5 text-orange-500" data-id="element-107" />
              </div>

              {/* Content Card */}
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-6 rounded-xl border border-gray-800 bg-gray-900/50 hover:bg-gray-900 hover:border-orange-900/50 transition-all duration-300" data-id="element-108">
                <div className="flex items-center gap-2 mb-2" data-id="element-109">
                  <span className="text-xs font-bold text-orange-500 uppercase tracking-wider" data-id="element-110">
                    Phase {phase.id}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-111">
                  {phase.title}
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-112">{phase.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}